export const initNavMobileAccordion = (): void => {
    const mobileMenu = document.getElementById('mobile-menu');
    if (!mobileMenu) return;

    // Garde contre la récursion : le clic synthétique qu'on déclenche sur un sibling
    // rebulle jusqu'ici et re-entrerait dans le handler sans ce flag.
    let handlingClick = false;

    mobileMenu.addEventListener('click', (event) => {
        if (handlingClick) return;

        const eventTarget = event.target as HTMLElement | null;
        const button = eventTarget?.closest<HTMLElement>('[data-collapse-toggle]');
        if (!button || !mobileMenu.contains(button)) return;

        const li = button.closest('li');
        const parentUl = li?.parentElement as HTMLElement | null;
        if (!parentUl) return;

        handlingClick = true;
        try {
            parentUl.querySelectorAll<HTMLElement>(':scope > li > [data-collapse-toggle]').forEach((sibling) => {
                if (sibling === button) return;
                const siblingTargetId = sibling.getAttribute('data-collapse-toggle');
                if (!siblingTargetId) return;
                const siblingPanel = document.getElementById(siblingTargetId);
                if (!siblingPanel || siblingPanel.classList.contains('hidden')) return;
                // Clic synthétique : laisse Flowbite fermer proprement + maintenir son état interne.
                sibling.click();
            });
        } finally {
            handlingClick = false;
        }
    });
};
